module.exports = __webpack_public_path__ + "static/favicon.95ec21ac.svg";